{
  "clear": "Очистити",
  "invalid": "(недійсне)",
  "loading": "Завантаження...",
  "noResults": "Результатів немає",
  "valid": "(дійсний)"
}
